import { z } from 'zod';

/** Shared search params for tax transaction table routes (app + client context). */
const numberish = z
  .union([z.number(), z.string()])
  .transform((v) => {
    const n = typeof v === 'string' ? Number(v) : v;
    return Number.isFinite(n) ? n : undefined;
  })
  .optional()
  .catch(undefined);

const booleanish = z
  .union([z.boolean(), z.string()])
  .transform((v) => (typeof v === 'string' ? v === 'true' : v))
  .optional()
  .catch(false);

const stringArrayish = z
  .union([z.array(z.union([z.string(), z.number()])), z.string(), z.number()])
  .transform((v) => {
    if (Array.isArray(v)) return v.map((x) => String(x));
    // support comma-separated query strings as well as single values
    const s = String(v);
    return s.includes(',') ? s.split(',').filter(Boolean) : [s];
  })
  .optional()
  .catch(undefined);

export const taxTransactionsSearchSchema = z
  .object({
    // page details
    pageSize: numberish,
    index: numberish,
    cursor: z.string().optional().catch(undefined),
    direction: z.string().optional().catch(undefined),

    // filters
    currencies: stringArrayish,
    txFlags: stringArrayish,
    txFlagsOperator: z.enum(['or', 'and']).optional().catch(undefined),
    exchanges: stringArrayish,
    txDateStart: z.string().optional().catch(undefined),
    txDateEnd: z.string().optional().catch(undefined),
    txDateStatic: z
      .enum(['oneDay', 'oneWeek', 'currentMonth', 'pastMonth', 'currentTaxYear'])
      .optional()
      .catch(undefined),
    contexts: stringArrayish,
    wallets: stringArrayish,
    contracts: stringArrayish,
    taxCategories: stringArrayish,
    carfCategories: stringArrayish,
    carfSubcategories: stringArrayish,
    ids: stringArrayish,
    hideFees: booleanish,

    // sorting
    sortColumn: z.string().optional().catch(undefined),
    sortOrder: z.enum(['asc', 'desc']).optional().catch(undefined),

    // modals
    msids: stringArrayish,
  })
  .catch({});
